module.exports = __webpack_public_path__ + "img/angle-double-left-solid.efde4c1b.svg";